export default "__VITE_ASSET__4DaVX8$H__"